import React from 'react';
import ExpandableContent from '../../components/ExpandableContent';

const LeadCard = ({ result, handleRowClick, isExpanded }) => {
  return (
    <div className="bg-[var(--background-color-card)] p-6 rounded-xl border border-[var(--color-border-subtle)] shadow-sm">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="font-semibold text-[var(--color-text-primary)] mb-2">
            <a href={`https://www.reddit.com/user/${result.username}`} target="_blank" rel="noopener noreferrer" className="hover:underline" data-testid="leadCard-usernameLink">
                {result.username}
            </a>
          </h3>
        </div>
        <div className="flex items-center gap-2">
          <a href={result.permalink} target="_blank" rel="noopener noreferrer" className="p-2 text-[var(--color-text-secondary)] hover:text-[var(--color-primary-accent)] transition-colors" data-testid="leadCard-permalinkLink">
            <span className="material-symbols-outlined text-xl">open_in_full</span>
          </a>
        </div>
      </div>
      <div className="prose prose-sm dark:prose-invert max-w-none text-[var(--color-text-secondary)] leading-relaxed">
        <ExpandableContent content={result.text} />
      </div>
      <div className="flex items-center gap-3 mt-4">
        <button onClick={() => handleRowClick(result.permalink)} className="bg-[var(--color-primary-accent)] text-white font-medium py-2 px-4 rounded-lg flex items-center gap-2 hover:bg-[var(--color-primary-accent-hover)] transition-colors" data-testid="leadCard-showToolsButton">
          <span className="material-symbols-outlined text-base">
            {isExpanded ? 'close' : 'send'}
          </span>
          {isExpanded ? 'Hide Tools' : 'Show Tools'}
        </button>
      </div>
    </div>
  );
};

export default LeadCard;
